import { v4 as uuid } from '@lukeed/uuid'
import Big from 'big.js'

import { browser } from '$app/environment'
import { getCurrentDay, getDateAfterDays } from '$lib/datetimes'
import { makeDocumentItem } from '$lib/factories'

import {
	type Estimate,
	type EstimateParams,
	EstimateStatus
} from './types'

// export const DEFAULT_COLOR = '#2924bf'
export const DEFAULT_COLOR = '#050505'

export function generateId() {
	if (browser) {
		return uuid()
	}
	return ''
}

export function makeEstimate(options: EstimateParams) {
	// Ugly code to solve: "Estimate - stub" error:
	//		ReferenceError: Cannot access 'DEFAULT_COLOR' before initialization at makeAccount
	// let defCOLOR = '#2924bf'
	let defCOLOR = '#050505'
	try {
		defCOLOR = DEFAULT_COLOR
	} catch (err) {
		// sentryError('ERROR:makeAccount() => cant set default constant values.')
		console.warn('ERROR:cant set default constant values.')
	}

	const today = getCurrentDay()

	const estimate: Estimate = {
		// TODO really??
		id: generateId(),
		account_id: '',
		archived: false,
		approved: false,
		invoiced: false,
		status: EstimateStatus.Draft,
		heading: 'Estimate',
		number: '',
		reference: '',
		issued: today,
		due: getDateAfterDays(today, 30),
		color: defCOLOR,
		notes: '',
		terms: '',
		items: [],
		items_delete: [],
		shipping_items: [],
		shipping_items_delete: [],
		discounts: [],
		taxes: [],
		subtotal: Big(0),
		discount: Big(0),
		tax: Big(0),
		grand_total: Big(0),
		original_number: '',
		last_sent_at: null,
		last_viewed_at: '',
		last_deleted_at: '',
		currency_id: 'usd',
		has_attachments: false,
		language_id: 'en-US',
		client_shipping_location_id: null
	}
	//console.log('document_data - estimate:', estimate)
	return {
		...estimate,
		...options, // validate fields
		items: [makeDocumentItem({ idx: 1 })]
	}
}
